export function getBaseTooltipHostStyle() {
    return {
        root: { display: "block" },
    };
}
export function getBaseTooltipStyle(theme) {
    return {
        root: Object.assign({ background: theme.customSemanticColors.solidBackgroundTertiary, borderRadius: "4px" }, theme.customSemanticElevations.tooltip),
    };
}
